export default __webpack_public_path__ + "static/mine-free_small-image_3-77c2f09b75b7d4e50acdf88d88a486e0.png";